import api from '@/utils/api'

export default {
    login(urlCode) {
        return api.post('users/login-by-urlcode', urlCode)
    },
    getCurrentUser() {
        return api.get('users/current')
    }
}
